module.exports = __webpack_public_path__ + "img/finance.c7472265.png";